import { render, staticRenderFns } from "./TradingAccountTable.vue?vue&type=template&id=25f520e5&"
import script from "./TradingAccountTable.vue?vue&type=script&lang=js&"
export * from "./TradingAccountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports